module.exports = __webpack_public_path__ + "static/img/lockLogin.1e53fbc6.png";